import { Badge } from "~/components/reusable/Badge"
import { Database } from "@phosphor-icons/react"

interface IncomingOrderSourceBadgeProps {
  source: "Hakio" | "ERP"
}

export const IncomingOrderSourceBadge = ({ source }: IncomingOrderSourceBadgeProps) => (
  <Badge size="sm" variant={source === "Hakio" ? "violet" : "gray"}>
    <Database className="w-3 h-3" />
    {source}
  </Badge>
)
